var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb'),_c('dataForm',{attrs:{"searchList":_vm.searchList},on:{"update:searchList":function($event){_vm.searchList=$event},"update:search-list":function($event){_vm.searchList=$event},"onSubmit":_vm.onSubmit}}),_c('liveTable',{ref:"liveTableRef",attrs:{"searchList":_vm.searchList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }